// @param {{ user: object|null, isTeamLead: boolean, adminUsers: object[]|undefined }} args
// @returns {object[]}
export function managerFilterUsers ({ user, isTeamLead, adminUsers }) {
  const list = Array.isArray(adminUsers) ? adminUsers : [];
  if (isTeamLead && user && !list.some((m) => m.id === user.id)) {
    return [user, ...list];
  }
  return list;
}
